module.exports = __webpack_public_path__ + "img/1-4.e0d6a3fb.jpg";